"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosConfig = {
    baseURL: 'https://api.ph.ubeeqo.com',
    timeout: 15000,
};
exports.apigeeConfig = {
    apikey: 'mhOvglg4AwXkuRB8S0dGCwkxLAqpf0G1',
};
